import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useNavigate } from "react-router-dom";

export const AdminCoachMessageManage = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchMessages = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await fetch(`${API_URL.MANAGE_COACH_MESSAGES}?page=${page}&limit=${limit}&search=${search}`, {
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Failed to fetch messages");
        }

        console.log(data.data);

        setMessages(data.data);
        setTotalPages(data.totalPages);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMessages();
  }, [page, search, staff.token]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this message?")) return;

    try {
      const response = await fetch(`${API_URL.DELETE_COACH_MESSAGE}${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${staff.token}`,
        },
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Failed to delete message");
      }
      setMessages(messages.filter((message) => message._id !== id));
    } catch (error) {
      setError(error.message);
    }
  };

  const handleReply = (id) => {
    navigate(`/administrator/message/coach-reply/${id}`);
  };

  return (
    <div className="flex h-screen">
      <StaffSideMenu />
      <div className="flex-1 p-6 bg-gray-100 pt-16 flex flex-col">
       
        <h1 className="text-2xl font-bold mb-4">Manage Coach Messages</h1>
        {error && <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>}
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div className="flex-1 overflow-auto border rounded shadow bg-white">
            <table className="table-auto w-full">
              <thead className="sticky top-0 bg-gray-200">
                <tr>
                  <th className="px-4 py-2 text-left">Coach Name</th>
                  <th className="px-4 py-2 text-left">Message</th>
                  <th className="px-4 py-2 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {messages.map((message, index) => (
                 <tr
                 key={message._id}
                 className={`${
                   message.read ? (index % 2 === 0 ? "bg-gray-50" : "bg-gray-100") : "bg-yellow-100"
                 }`} // Highlight unread messages with a distinct color
               >
                   <td className={`px-4 py-2 ${!message.read ? "font-bold" : ""}`}>
                    {message.senderName}
                    </td>
                    <td className={`px-4 py-2 ${!message.read ? "font-bold" : ""}`}>
                    {message.message}
                    </td>
                    <td className="px-4 py-2">
                      <button
                        onClick={() => handleReply(message._id)}
                        className="mr-2 px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                      >
                        Reply
                      </button>
                      <button
                        onClick={() => handleDelete(message._id)}
                        className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="flex justify-between mt-4">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Previous
              </button>
              <span>
                Page {page} of {totalPages}
              </span>
              <button
                onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={page === totalPages}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
